export default {
  api: 'https://api.fubo.tv',
  web: 'https://www.fubo.tv',
  formConfig: {
    TVE: {
      loginFormPath: '/partners/tve/connect',
    },
    OAUTH: {
      loginFormPath: '/partners/connect',
    },
    ZENDESK: {
      loginFormPath: '/partners/zendesk/connect',
    },
    CANNY: {
      loginFormPath: '/partners/canny/connect',
    },
    ESPN_ACTIVATE: {
      loginFormPath: '/partners/espn/activate',
    },
  },
};
